import React from 'react';

import { Block } from '../common/Block.jsx';
import { Clickable, Hoverable } from '../common/Button.jsx';
import Defaults from '../layout/Defaults.jsx';
import { FormContainer, withSubscriptionLogging, withValidationV2 } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { Wrapper as InputWrapper, Required } from '../common/Input.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Utilities from '../common/Utilities.jsx';

// #region SUBSCRIBE FORM V1 (-- DEPRECATED Use `SubscribeFormV2` --)

function _SubscribeFormV1Component(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => {
        setId(Utilities.generateUniqueId());
    }, []);
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            Email: props.formData.Email,
            Name: props.formData.Name,
            Robots: props.formData.token,
            Sub: props.config && props.config.subdomain
        }
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.tags && props.blockConfig.layout.tags.length > 0) {
            postData.Origin = props.blockConfig.layout.tags.map(d => d.value);
        }
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        props.onSubmit('/api/subscriptions', postData);
    }, [props.formData.token])
    const buttonClassName = props.formData.formState != undefined ? ` btn--${props.formData.formState}` : '';
    const disabled = props.builder == true || props.disabled == true || props.formData.formState != undefined;
    let buttonHoverProps, buttonSpacing, buttonStyle, inputSpacing, inputStyle;
    if (props.blockConfig) {
        if (props.blockConfig.button) {
            buttonStyle = {};
            Block.mapStyleConfigProps(buttonStyle, props.blockConfig.button, (propName, propValue, propUnit) => {
                let _propValue = propValue;
                if (_propValue && propUnit) {
                    _propValue = `${_propValue}${propUnit}`;
                }
                switch (propName) {
                    case 'lineSpacing':
                        buttonSpacing = _propValue;
                        return true;
                    default:
                        if (propName.indexOf('Hover') < 0 || !_propValue) {
                            break;
                        }
                        if (!buttonHoverProps) {
                            buttonHoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        buttonHoverProps[_propName] = _propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.input) {
            inputStyle = {};
            Block.mapStyleConfigProps(inputStyle, props.blockConfig.input, (propName, propValue, propUnit) => {
                let _propValue = propValue;
                if (_propValue && propUnit) {
                    _propValue = `${_propValue}${propUnit}`;
                }
                switch (propName) {
                    case 'lineSpacing':
                        inputSpacing = _propValue;
                        return true;
                }
            });
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    if (props.builder || props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let ButtonComponent = Clickable;
    if (buttonHoverProps != undefined) {
        ButtonComponent = Hoverable;
    }
    let content = (
        <form id="subscribeForm" className="form form--sub" style={layoutStyles.style}>
            <div className="form__inn" style={{ marginBottom: inputSpacing }}>
                <InputWrapper size="medium">
                    <Required
                        disabled={disabled}
                        id="subscribeFormName"
                        errors={props.formData.errors}
                        name="Name"
                        placeholder="Enter Name"
                        style={inputStyle}
                        value={props.formData.Name}
                        onChange={props.onChange} />
                </InputWrapper>
            </div>
            <div className="form__inn">
                <InputWrapper size="medium">
                    <Required
                        disabled={disabled}
                        id="subscribeFormEmail"
                        errors={props.formData.errors}
                        name="Email"
                        placeholder="Enter Email Address"
                        style={inputStyle}
                        type="email"
                        value={props.formData.Email}
                        onChange={props.onChange} />
                </InputWrapper>
            </div>
            <div className="form--sub__inn" style={{ marginTop: buttonSpacing }}>
                <ButtonComponent
                    className={`btn btn--outl btn--md form__btn${buttonClassName}`}
                    disabled={disabled}
                    hoverProps={buttonHoverProps}
                    style={buttonStyle}
                    type="submit"
                    onClick={props.onValidate}>
                    <React.Fragment><div className="submission-status" /> {props.formData.formState == 'success' ? 'Subscribed' : 'Subscribe'}</React.Fragment>
                </ButtonComponent>
            </div>
        </form>
    );
    if (layoutStyles.containerStyle) {
        if (layoutStyles.containerStyle.maxWidth) {
            layoutStyles.containerStyle.width = '100%';
        }
        content = <div className="form--container" style={layoutStyles.containerStyle}>{content}</div>
    }
    if (props.onContent) {
        content = props.onContent(content)
    }
    return content;
}
const SubscribeFormV1Component =
    withSubscriptionLogging(
        withValidationV2(
            _SubscribeFormV1Component,
            ['Name', 'Email']
        ),
        'footer');
const SubscribeFormV1 = { Component: SubscribeFormV1Component };

// #endregion SUBSCRIBE FORM V1

// #region SUBSCRIBE FORM V2

function _SubscribeFormV2Component(props) {
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            AddressLineOne: props.formData.AddressLineOne,
            AddressLineTwo: props.formData.AddressLineTwo,
            City: props.formData.City,
            Country: props.formData.Country,
            Email: props.formData.Email,
            Name: props.formData.Name,
            Phone: props.formData.Phone,
            Robots: props.formData.token,
            State: props.formData.State,
            Sub: props.config && props.config.subdomain,
            Zip: props.formData.Zip
        }
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.tags && props.blockConfig.layout.tags.length > 0) {
            postData.Origin = props.blockConfig.layout.tags.map(d => d.value);
        }
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        switch (props.pageType) {
            case PageType.ExhibitionDetail:
                if (!props.data || !props.data.show || !props.data.show.showId) {
                    break;
                }
                const showId = parseInt(props.data.show.showId, 10)
                if (!isNaN(showId)) {
                    break;
                }
                if (!postData.Origin) {
                    postData.Origin = [];
                }
                postData.Origin.push(props.data.show.showId);
                break;
        }
        props.onSubmit('/api/subscriptions', postData);
    }, [props.formData.token])

    let className;
    let editor = false;
    switch (props.pageType) {
        case PageType.Form.FooterSubscribe:
            className = 'foot--whitelabel'
        // Intentional fallthrough
        case PageType.Form.Subscribe:
            editor = true;
            break;
    }
    let Form;
    if (props.pageType) {
        Form = Name.Block.SubscribeForm.baseFromContext(props.pageType);
    } else {
        Form = props.blockType == Name.Block.Footer.SubscribeForm.Container ? Name.Block.Footer.SubscribeForm : Name.Block.SubscribeForm;
    }
    let additionalFields = [];
    const handleValidate = () => props.onValidate(additionalFields);
    const handleFormFieldProps = React.useCallback(({ blockConfig, type }, formFieldProps) => {
        switch (type) {
            case FormField.Email:
                formFieldProps.placeholderText = 'Email Address *';
                formFieldProps.type = 'email';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField[Form.Container].ErrorMessage:
                formFieldProps.editor = editor;
                formFieldProps.error = props.formData.errorMessage;
                break;
            case FormField.Name:
                formFieldProps.placeholderText = 'Full Name *';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField.Phone:
                formFieldProps.placeholderText = 'Phone Number';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.AddressLine1:
                formFieldProps.placeholderText = 'Address Line 1';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.AddressLine2:
                formFieldProps.placeholderText = 'Address Line 2';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.City:
                formFieldProps.placeholderText = 'City';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.Country:
                formFieldProps.placeholderText = 'Country';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.State:
                formFieldProps.placeholderText = 'State';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.Zip:
                formFieldProps.placeholderText = 'Zip';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField[Form.Container].SubmitButtonV1:
            case FormField[Form.Container].SubmitButtonV2:
                formFieldProps.formState = props.formData.formState;
                formFieldProps.inPopup = props.inPopup;
                formFieldProps.onClick = handleValidate;
                break;
            case FormField[Form.Container].SuccessMessage:
                formFieldProps.editor = editor;
                formFieldProps.formState = props.formData.formState;
                break;
        }
    }, [props.formData.errorMessage, props.formData.formState]);

    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.design;
        } else {
            contentConfig = Defaults.Block[Form.Container];
        }
    }
    return (
        <FormContainer.Component
            {...props}
            builder={props.builder || props.disabled}
            className={className}
            contentConfig={contentConfig}
            editor={editor}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const SubscribeFormV2CustomPageComponent =
    withSubscriptionLogging(
        withValidationV2(
            _SubscribeFormV2Component,
            ['Email', 'Name']
        ),
        'page');

const SubscribeFormV2FooterComponent =
    withSubscriptionLogging(
        withValidationV2(
            _SubscribeFormV2Component,
            ['Email', 'Name']
        ),
        'footer');
const SubscribeFormV2 = { CustomPage: SubscribeFormV2CustomPageComponent, Footer: SubscribeFormV2FooterComponent };

// #endregion SUBSCRIBE FORM V2

export {
    SubscribeFormV2,

    // DEPRECATED
    SubscribeFormV1
}